import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _sendFeedback;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchSendFeedback } from '../../Repositories/feedback-form/v1/send-feedback';
import { EEventType } from '../../types/eventEmitter';
import { prepareParameters } from './mappers/prepareParameters';
export function sendFeedback(_x, _x2) {
  return (_sendFeedback = _sendFeedback || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, parameters) {
    var httpApi, emitter, logger, preparedParameters, sendFeedbackResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = context.httpApi, emitter = context.emitter, logger = context.logger;
          _context.prev = 1;
          preparedParameters = prepareParameters(parameters);
          _context.next = 5;
          return fetchSendFeedback({
            httpApi: httpApi,
            parameters: preparedParameters
          });
        case 5:
          sendFeedbackResponse = _context.sent;
          if (!(sendFeedbackResponse.statusCode !== 200)) {
            _context.next = 10;
            break;
          }
          logger.warning("[Degradation] fetchSendFeedback: ".concat(sendFeedbackResponse.response.message), {
            domain: 'frontend-feedback-form-widget.services.sendFeedback'
          });
          emitter.emit(EEventType.SendFormFailed);
          return _context.abrupt("return", {
            status: 'failed',
            errorMessage: sendFeedbackResponse.response.message || ''
          });
        case 10:
          emitter.emit(EEventType.SendFormSucceed, {
            topic: parameters.formValue.topic || null
          });
          return _context.abrupt("return", {
            status: 'succeed',
            ticketId: sendFeedbackResponse.response.ticketId || null
          });
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'frontend-feedback-form-widget.services.sendFeedback'
          });
          emitter.emit(EEventType.SendFormFailed);
          return _context.abrupt("return", {
            status: 'failed',
            errorMessage: 'Что-то пошло не так, попробуйте ещё раз'
          });
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 14]]);
  }))).apply(this, arguments);
}